import { useQueryWithUserId } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

/**
 * This is to track the download upload bid template query key in react query cache.
 */
const DOWNLOAD_UPLOAD_BID_TEMPLATE = 'download-upload-bid-template-key';

/**
 * Add some docs comments here.
 */
export const useDownloadUploadBidTemplateQuery = (categoryId: string) => {
  const { data, error, isError, refetch, isSuccess, isPending } =
    useQueryWithUserId({
      queryKey: [DOWNLOAD_UPLOAD_BID_TEMPLATE, categoryId],
      enabled: false,
      queryFn: () => BIDS_API.downloadUploadBidFileTemplate(categoryId),
    });

  return {
    error,
    isError,
    data,
    isPending,
    refetch,
    isSuccess,
  };
};
